import Logger from './Logger'

export const updateQuirks = async (quirks, context) => {
  const logger = Logger.getInstance()
  if (!quirks || Object.keys(quirks).length === 0 || !context) {
    logger.error('UniformQuirksError', 'Invalid data passed to quirks')
    return
  }

  try {
    await context.update({
      quirks
    })
  } catch (error) {
    logger.error('UniformQuirksError', error, 'Error updating quirks')
  }
}
